<template lang="pug">
  .purchase-panel(v-if="product.id" body-scroll-lock-ignore)
    .purchase-panel-inner.xs-12
      .row
        button.back.btn-reset.upper.bold.xs-f-xsmall.sm-f-small.max-at-tweak.clickable(@click="close")
          span.icon-caret-left.xs-f-xxsmall.sm-f-xsmall.max-at-tweak
          | back
      
      .xs-12.line

      .fixed-width-tweak-upper
        .product-wrap.xs-12
          .product-info.xs-12(v-if="breakpoint == 'desktop'")
            .you-choose.xs-12.text-center(v-if="hasBenefits")
              p.xs-f-xlarge.max-at-tweak You choose: just one box, or a 
                span.xs-f-xxxlarge.max-at-tweak Madison&nbsp;Reed Membership?

            .product-details.xs-12
              .product-image(v-if="productImage")
                img.full-width(:src="productImage.url" :alt="productImage.alt_text")
              
              .prod-info
                p.upper.color-slate.xs-f-xsmall.max-at-tweak {{product.name}}
                p.xs-f-medium.max-at-tweak {{product.short_description}}

          .product-info.xs-12(v-else)
            .product-details.xs-12.text-center
              .product-image(v-if="productImage")
                img.full-width(:src="productImage.url" :alt="productImage.alt_text")

              .you-choose(v-if="hasBenefits")
                p.xs-f-medium.sm-f-xmedium.lg-f-xlarge.max-at-tweak You choose: just one box, or a 
                  b Madison&nbsp;Reed Membership
                  | ?

          form.purchase-wrap.xs-12(@submit.prevent="addToBag")
            .purchase-wrap-inner.xs-12
              fieldset.xs-12
                legend.tooltip Select one time or membership

                mrRadio.purchase-type.one-time.xs-12.xs-f-medium.sm-f-xmedium.max-at-tweak(v-model="isSubscription" :value="false" name="purchase type")
                  .title-wrap
                    span(v-html="product.oneTimeRadioText")
                  .price-wrap
                    span(data-mr-ass="pdp-price") {{product.price | currency}}

                mrRadio.purchase-type.subscription.xs-12.xs-f-medium.sm-f-xmedium.max-at-tweak(v-model="isSubscription" :value="true" name="purchase type")
                  .title-wrap
                    span(v-html="product.subscriptionRadioText")
                  .price-wrap
                    span(data-mr-ass="pdp-price") {{product.sub_price | currency}}
                    span.most-popular.upper.bold.color-mr-blue.xs-f-xxsmall.max-at-tweak most popular

              .dropdown-wrap.xs-12(v-if="isSubscription && defaultSubFrequency")
                p.color-slate.light.xs-f-xsmall.max-at-tweak Delivered automatically: 
                dropdown(label="select frequency" v-model="subFrequency")
                  option(v-for="freq in subFrequencies" :value="freq" :key="freq") Every {{freq}} weeks
            
            .xs-12.line

            .panel-cta-wrap.xs-12.text-center
              .extra-tube-wrap.xs-12(v-if="product.product_type == 'color_kit'")
                mrInputCheckbox(:label="product.extraTubeText" v-model="extraTube" dataMrAss="extra-tube-input")

              .panel-cta.xs-12
                button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(data-mr-ass="add-to-bag") add to bag

      .membership-benefits-wrap.xs-12(v-if="hasBenefits")
        .benefits-table-title.xs-12.text-center
          p.color-white.upper.xs-f-small.md-f-medium.max-at-tweak why become a member

        .fixed-width-tweak-upper
          .benefits-table-wrap.xs-12
            .benefits-table
              .benefit(v-for="benefit in membershipBenefits")
                .check-wrap.text-center.delivery-benefit
                  span.icon-check-nobox.color-purple.xs-f-large.max-at-tweak
                .check-wrap
                .benefit-title
                  p.xs-f-small.max-at-tweak(v-html="benefit")

              .benefit(v-for="benefit in product.oneTimeBenefits")
                .check-wrap.text-center.delivery-benefit
                  span.icon-check-nobox.color-purple.xs-f-large.max-at-tweak
                .check-wrap.text-center.reqular-benefit
                  span.icon-check-nobox.color-purple.xs-f-large.max-at-tweak
                .benefit-title
                  p.xs-f-small.max-at-tweak(v-html="benefit")

      .xs-12.line

      .based-on-selection.xs-12
        .membership-selected.color-purple.xs-f-xxlarge.max-at-tweak(v-if="isSubscription")
          p.xs-f-xxlarge.max-at-tweak Time-saving
          p.xs-f-xxlarge.max-at-tweak Money-saving
          p.xs-f-xxlarge.max-at-tweak Best color ever

        .one-box-selected.text-center.color-purple.xs-f-large.sm-f-xlarge.max-at-tweak(v-if="!isSubscription")
          p.color-purple.semi-bold.upper.xs-f-large.sm-f-xlarge.max-at-tweak reasons to love membership
          ul.normal.text-left.xs-f-xxlarge.max-at-tweak
            li.xs-f-large.sm-f-xlarge.max-at-tweak Save money on every order
            li.xs-f-large.sm-f-xlarge.max-at-tweak Cancel online anytime
            li.xs-f-large.sm-f-xlarge.max-at-tweak More free time, more me time

      .bottom-back-wrap
        button.back.btn-reset.upper.bold.xs-f-xsmall.sm-f-small.max-at-tweak(@click="close")
          span.icon-caret-left.xs-f-xxsmall.sm-f-xsmall.max-at-tweak
          | back

</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import mrRadio from "../../mrRadio";
  import mrInputCheckbox from "../../mrInputCheckbox";

  export default {
    name: "PurchasePanel",

    components: {
      mrRadio,
      mrInputCheckbox
    },

    data() {
      return {
        isSubscription: true,
        subFrequency: 4,
        defaultFreqSet: false,
        extraTube: false
      }
    },

    computed: {
      ...mapState('pdp', [
        'product',
        'attachableProdIds'
      ]),
      ...mapState('customer', ['cdata']),
      ...mapState('colorAdvisor', ['answers']),

      ...mapGetters('customer', ['productIdInPurchaseList']),
      ...mapGetters('cart', [
        'productIdInCart',
        'suggestedAddons'
      ]),

      breakpoint() {
        return this.$root.windowData.breakpoint;
      },

      hasBenefits() {
        return this.product && this.product.membershipBenefits.length;
      },

      membershipBenefits() {
        var benefits = [];

        if (this.product && this.product.membershipBenefits) {
          this.product.membershipBenefits.forEach((benefit, index) => {
            // conditionally add firstTimeMemberBenefit to membership benefits
            if (index == 1 && this.product.firstTimeMemberBenefit && !(this.cdata.activeSubscriber || this.cdata.formerSubscriber)) {
              benefits.push(this.product.firstTimeMemberBenefit);
            }
            benefits.push(benefit);
          });
        }

        return benefits;
      },

      productImage() {
        if (!this.product) {
          return null
        }
        if (this.product.imagery.backie && this.product.imagery.backie.url) {
          return this.product.imagery.backie;
        }
        if (this.product.imagery.smallNoBottle && this.product.imagery.smallNoBottle.url) {
          return this.product.imagery.smallNoBottle;
        }
        if (this.product.imagery.standard && this.product.imagery.standard.url) {
          return this.product.imagery.standard;
        }
      },

      defaultSubFrequency() {
        if (this.$root.advisorAnswers && this.$root.advisorAnswers.frequency && !this.defaultFreqSet) {
          this.subFrequency = this.$root.advisorAnswers.frequency;
          this.defaultFreqSet = true;
          return this.$root.advisorAnswers.frequency;
        }
        return 4;
      },

      subFrequencies() {
        if (!this.product || !this.product.product_type_sub_frequencies) {
          return [];
        }

        return this.product.product_type_sub_frequencies.split(",");
      },

      colorProProductId() {
        let colorProProductId;

        if (this.product.product_type == "light_works" && this.answers.hair_length === 'short' && this.product.colorProProductTwo && this.product.colorProProductTwo.id) {
          colorProProductId = this.product.colorProProductTwo.id;
        } else if (this.product.lowGrayProduct) {
          colorProProductId = this.product.lowGrayProduct.id;
        } else if (this.product.colorProProduct && this.product.colorProProduct.id) {
          colorProProductId = this.product.colorProProduct.id;
        }

        return colorProProductId;
      }
    },

    methods: {
      ...mapActions('cart', [
        'addToCart',
        'loadCart'
      ]),

      ...mapActions('xsell', [
        'openPdpXsellModal',
        'getProProduct'
      ]),

      ...mapActions('colorAdvisor', ['initAnswers']),
      ...mapMutations('pdp', ['clearAttachableProdIds']),

      close() {
        this.$emit('hide-modal');
      },

      addToBag() {
        this.addToCart({
          cartType: 'active',
          ctaSource: 'PurchasePanel',
          productId: this.product.id,
          subscription: this.isSubscription ? this.subFrequency : 0,
          extra: this.extraTube,
          attachableProdIds: this.attachableProdIds
        }).then(() => {
          this.initXsell();
          this.clearAttachableProdIds();
        });
      },

      initXsell() {
        if (this.colorProProductId && !this.productIdInPurchaseList(this.colorProProductId) && !this.productIdInCart(this.colorProProductId)) {
          //- load and set proProduct and open xsell modal
          return this.getProProduct(this.colorProProductId).then(() => {
            this.openPdpXsellModal();
          });
        } else if (this.suggestedAddons.length > 0) {
          //- check if there are other xsell products available and open the modal
          return this.openPdpXsellModal();
        }
        //- if no xsell available go straight to cart
        window.location = '/cart';
      }
    },

    mounted() {
      //- ensure data for xsell is loaded
      this.loadCart();
      this.initAnswers();
    }
  }
</script>

<style scoped lang="stylus">
  .purchase-panel
    background-color color-gray-light
    height 100%
    width 100%
    overflow auto
    
    .purchase-panel-inner
      padding-bottom 5em
    
    .back
      width 100%
      padding 1em
    
    .line
      border-top 1px solid color-gray-triple-nines
      
    .purchase-wrap
      .purchase-type
        line-height 21px
        padding 0.5em 0
          
        .mr-radio
        .title-wrap
        .price-wrap
          display inline-block
          vertical-align top
          
        .price-wrap
          float right
          text-align right
          
          .most-popular
            display block
            padding-top 0.25em
            
      .dropdown-wrap
        padding-left 2em
        padding-bottom 0.25em
        
        .mr-dropdown
          width 14em
          
      .panel-cta-wrap
        padding-bottom 1.5em
        
        .extra-tube-wrap
          padding 1em 0
          margin-bottom 0.5em
      
    .membership-benefits-wrap
      .benefits-table-title
        background-color #9fbce4
        padding 0.5em
        
      .benefits-table-wrap
        .benefits-table
          .benefit
            border-top none
            display flex
            
            .benefit-title
            .check-wrap
              display inline-block
              vertical-align top
              
            .benefit-title
              width 66%
              padding 0.75em
              
            .delivery-benefit
              background-color #d7e2f4
            
            .reqular-benefit
              background-color #ebebeb
              
            .check-wrap
              width 13%
              padding-top 0.5em
            
        .benefits-table-title
          .benefit
            border-top 1px solid #ccc

    .based-on-selection
      display flex
      justify-content center
      align-items center
      margin 2em 0
    
      .membership-selected
      .one-box-selected
        display inline-block
        border 1px solid color-mr-purple
        margin-top 0.5em
        display inline-block
        padding 0.7em

    .bottom-back-wrap
      position absolute
      left 0
      right 0
      bottom 0
      border-top 1px solid color-gray-triple-nines
      
    @media mq-mobile
      .product-wrap
        padding 0 5%
        
        .product-info
          .product-details
            .product-image
              width 5.5em
              
            .you-choose
              width 14em
        
    @media mq-tablet
      .product-wrap
        padding 0 10%
        
        .product-info
          .product-details
            .product-image
              width 7.5em
              
            .you-choose
              width 16em
              
      .purchase-wrap
        .purchase-wrap-inner
          padding 0 5%
        
      .membership-benefits-wrap
        .benefits-table-wrap
          padding 0 10%
    
    @media mq-desktop-md-less
      .product-wrap
        .product-info
          .product-details
            padding 1.5em 0
            
            .product-image
            .you-choose
              display inline-block
              vertical-align top
            
            .you-choose
              text-align right
              
    @media mq-desktop-md
      .product-wrap
        padding 0 20%
        
        .product-info
          .product-details
            .product-image
              width 9.5em
              
            .you-choose
              width 16em
              
      .purchase-wrap
        .purchase-wrap-inner
          padding 0 10%
        
      .membership-benefits-wrap
        .benefits-table-wrap
          padding 0 15%
          
    @media mq-desktop-plus
      .product-wrap
        padding 0 25%
        
        .product-info
          .product-details
            padding 1.5em 20%
            
            .product-image
            .prod-info
              display inline-block
              vertical-align top
            
            .product-image
              width 5.5em
              
            .prod-info
              width 14em
              padding-left 1em
        
        .you-choose
          padding 1.5em 0
          border-bottom 1px solid color-gray-triple-nines
      
      .purchase-wrap
        .purchase-wrap-inner
          padding 0 10%
      
      .membership-benefits-wrap
        .benefits-table-wrap
          padding 0 25%

</style>
